
// NOTE: Regarding handlers for broadcast events, if the function is going
//       to update any UI, make sure that it's not a surprising change to
//       any subscriber.
//
//       E.g.:  When a message is sent, the sending user should expect the
//       form to be reset and the modal to be dismissed.  Any other subscribers
//       would not expect this behavior, especially if they were in the middle
//       of creating a new message.
//       All subscribers however should expect the messages list to be updated
//       with the newly created message regardless of who sent it.
//
//       In general, it seems to be a good pattern to trigger current-user-centric
//       changes in the controller's response, and trigger subscriber-centric
//       changes in the broadcast event handlers.

// console.log('in app')

window.App = {
  ready(func) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', func);
    } else {
      setTimeout(func, 0);
    }
  },

  modal_ready(func) {
    return $(document).on("modal:load", func);
  },

  emit: (event_name, payload, el) => {
    // console.log('in emit: ', event_name, payload);
    const e = new CustomEvent(event_name, { bubbles: true, cancelable: true, detail: payload });

    if (el) {
      return el.dispatchEvent(e);
    } else {
      return document.dispatchEvent(e);
    }
  },

  subscribe: (event_name, callback) => {
    return document.addEventListener(event_name, callback, false);
  },

  unsubscribe: (event_name, callback) => {
    return document.removeEventListener(event_name, callback, false);
  },

  logged_in() {
    return $("meta[name=account-uuid]").length > 0;
  },


  is_phone() {
    return $("body").hasClass("phone");
  },

  log() {
    // console.log('in app log!')
    if (location.href.match(/localhost/)) {
      console.log.apply(console, arguments);
    }
  }
};

export default App;
